<template>
  <div class="NewsDetail">
    <section-header heading="2" ja="「TOMORROW X TOGETHER with lalamee」期間限定イベント決定！"/>
    <div>
      <div class="text-area">
        22.08.31更新<br><br>
        「TOMORROW X TOGETHER with lalamee」期間限定イベント決定！<br><br>
        <img src="@/assets/Png/News/TXT/image_news_TXT_collabo.png" style="max-width: 100%;">
        <br><br>
        <b>■実施期間</b>
        <br><br>
        2022年8月12日（金）～2022年9月12日（月）
        <br><br>
        <b>■対象機種</b>
        <br><br>
        <center>『lalamee（ララミー）』</center><br>
        <center>
          <img src="@/assets/Png/News/TXT/image_news_lalamee.png" style="max-width: 80%;">
        </center>
        <br><br>
        <center>遊べるお店は
          <a href="https://o.puri.jp/appfw/locationLalamee/">こちら</a>
        </center>
        <br><br>
        <b>■内容</b>
        <br><br>
        スタンプ…全16種、フォトカラー…1セット
        <br><br>
        <b>◆「TOMORROW X TOGETHER」限定スタンプ</b>
        <br><br>
        <center>
          <img src="@/assets/Png/News/TXT/image_news_TXT_collabo02.png" style="max-width: 100%;">
        </center>
        <br><br>
        メンバーは全身スタンプで登場！
        <br><br>
        <center>
          <img src="@/assets/Png/News/TXT/image_news_TXT_collabo03.png" style="max-width: 100%;">
        </center>
        <br><br>
        <b>◆「TOMORROW X TOGETHER」限定フォトカラー</b>
        <br><br>
        <center>
          <img src="@/assets/Png/News/TXT/image_news_TXT_collabo04.png" style="max-width: 100%;">
        </center>
        <br><br>
        さらに！コラボ実施期間中、lalameeでTOMORROW X TOGETHERの楽曲が聴けます。<br>
        期間によって違う曲が楽しめる！
        <br><br>
        8/12-8/30：「Good Boy Gone Bad」
        <br><br>
        8/31 -9/12： 8/31リリースの日本３rdシングルの楽曲計３曲
        <br><br>
        <center>
          遊べるお店は
          <a href="https://o.puri.jp/appfw/locationLalamee/">こちら</a>
        </center>
        <br><br>
        <b>■「TOMORROW X TOGETHER」とは</b>
        <br><br>
        SOOBIN、YEONJUN、BEOMGYU、TAEHYUN、HUENINGKAIの5人で結成された「TOMORROW X TOGETHER」は ’それぞれ違う君と僕がひとつの夢で集まって共に明日を作って行く’という意味で、ひとつの夢と目標のために集まった少年たちが互いにシナジーを発揮するZ世代をリードするボーイグループ。
        <br><br>
        <b>2022.8.31 Release</b>
        <br><br>
        日本3rdシングル「GOOD BOY GONE BAD」
        <br><br>
        「Good Boy Gone Bad」の日本語バージョンに加え、メンバーがMOAを想いソングライティングした楽曲やシンガーソングライターの川崎鷹也が楽曲提供した日本オリジナル楽曲を収録!
        <br><br>
        01 - Good Boy Gone Bad [Japanese Ver.]
        <br>
        02 - 君じゃない誰かの愛し方 (Ring)
        <br>
        03 - ひとりの夜 (Hitori no Yoru)
        <br>
        <br>
        セガ公式SNSでもコラボ情報を発信中！
        <br><br>
        <div class="snsWrapper --snsIcons">
          <a class="snsIcon" href="https://www.instagram.com/sega_purikura/">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_01_IG.jpg">
          </a>
          <a class="snsIcon --x" href="https://twitter.com/SEGA_purikura/">
            <img src="@/assets/Png/SNS/Twitter_Social_Icon_Rounded_Square_Color.png">
          </a>
          <a class="snsIcon" href="https://lin.ee/BncFzGc">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_03_LINE.jpg">
          </a>
        </div>
        <center class="sns">
          <a href="https://www.instagram.com/sega_purikura/">Instagram</a>
          <a href="https://twitter.com/SEGA_purikura/">X(旧Twitter)</a>
          <a href="https://lin.ee/BncFzGc">LINE</a>
        </center>
      </div>
    </div>

    <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
    <sub-btn @click="onHome()">ホームに戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader";
import SubBtn from '../components/SubBtn.vue'

export default {
  name: "NewsDetail",
  components: {SectionHeader, SubBtn},
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    }
  },
  methods: {
    onNewsList() {
      this.$router.push('/newsList')
    },
    onHome() {
      this.$router.push('/')
    },
  }
}
</script>

<style lang="scss" scoped>
.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;
    img {
      max-width: 100%;
    }
    .edge {
      box-shadow: 0 0 5px rgba(0,0,0,0.12);
    }
    p {
      margin-top: 1em;
    }

    .snsIcon {
      display: inline-block;
      height: 67px;
      img {
        height: 67px;
      }
    }
    .--x {
      height: 49px;
      img {
        width: 49px;
        height: 100%;
      }
    }

    .snsWrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &>a:nth-of-type(1){
        margin-right: 15px;
      }
      &>a:nth-of-type(2){
        margin-right: 20px;
      }
    }
    .centerBlock {
      display: flex;
      justify-content: center;
      & > img:last-of-type,
      & > a:last-of-type { margin-left: 20px; }
    }
  }
  .sns {
    a { margin: 0 12px; }
  }
}
</style>
